import { SVGProps } from 'react'

export const LineParking = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g fill="currentColor">
			<path d="M9.3 6.7v10.6h1.5V14h2.3c2 0 3.6-1.6 3.6-3.6 0-2.1-1.6-3.7-3.6-3.7zm5.8 3.6c0 1.3-1 2.3-2.1 2.3h-2.3V8.2H13c1.2 0 2.1 1 2.1 2.1" />
			<path d="M19.2 4.8c-1.9-1.9-4.5-3-7.2-3s-5.3 1.1-7.2 3-3 4.5-3 7.2 1.1 5.3 3 7.2 4.5 3 7.2 3 5.3-1.1 7.2-3 3-4.5 3-7.2-1.1-5.3-3-7.2M12 20.7c-2.3 0-4.5-.9-6.1-2.5s-2.5-3.8-2.5-6.1.9-4.5 2.5-6.1S9.7 3.5 12 3.5s4.5.9 6.1 2.5 2.5 3.8 2.5 6.1-.9 4.5-2.5 6.1-3.8 2.5-6.1 2.5" />
		</g>
	</svg>
)
